<template>
    <div>

        <kgr-school-year-data-provider
            v-slot="scope"
            :kindergarten-id="kindergartenId"
        >
            <div>
                <table class="kgr-table kgr-table--block kgr-table--striped">
                    <thead>
                        <tr class="kgr-table__row">
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('name') }}
                            </th>
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('start') }}
                            </th>
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('end') }}
                            </th>
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('bookingNote.closingDate') }}
                            </th>
                            <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions">
                                {{ $t('action') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="kgr-table__row">
                            <td class="kgr-table__cell">
                                <input
                                    v-model="newSchoolYear.name"
                                    type="text"
                                    class="kgr-input"
                                    value="'1'"
                                    axlength="100"
                                    :class="{ 'is-invalid': !newSchoolYear.isEmpty() && !isValidName(newSchoolYear) }"
                                    @blur="save(newSchoolYear, scope.reload)"
                                /></input>
                                <div
                                    v-if="hasErrorAtField(newSchoolYear,'name')"
                                    class="errors kgr-color kgr-color--error"
                                >
                                    {{ errorMessageForField(newSchoolYear,'name') }}
                                </div>
                            </td>
                            <td class="kgr-table__cell">
                                <kgr-date-picker
                                    v-model="newSchoolYear.start"
                                    :invalid="!newSchoolYear.isEmpty() && !isValidStart(newSchoolYear)"
                                    @post-input="save(newSchoolYear, scope.reload, 'start')"
                                />
                                <div
                                    v-if="hasErrorAtField(newSchoolYear,'start')"
                                    class="errors kgr-color kgr-color--error"
                                >
                                    {{ errorMessageForField(newSchoolYear,'start') }}
                                </div>
                            </td>
                            <td class="kgr-table__cell">
                                <kgr-date-picker
                                    v-model="newSchoolYear.end"
                                    :invalid="!newSchoolYear.isEmpty() && !isValidEnd(newSchoolYear)"
                                    @post-input="save(newSchoolYear, scope.reload, 'end')"
                                />

                                <div
                                    v-if="hasErrorAtField(newSchoolYear,'end')"
                                    class="errors kgr-color kgr-color--error"
                                >
                                    {{ errorMessageForField(newSchoolYear,'end') }}
                                </div>
                            </td>
                            <td class="kgr-table__cell">
                                <kgr-date-picker
                                    v-model="newSchoolYear.immutableDate"
                                    :invalid="!newSchoolYear.isEmpty() && !isValidImmutableDate(newSchoolYear)"
                                    @post-input="save(newSchoolYear, scope.reload)"
                                />
                                <div
                                    v-if="hasErrorAtField(newSchoolYear,'immutableDate')"
                                    class="errors kgr-color kgr-color--error"
                                >
                                    {{ errorMessageForField(newSchoolYear,'immutableDate') }}
                                </div>
                            </td>
                            <td class="kgr-table__cell kgr-table__cell--actions">
                                <kgr-icon-reset
                                    :title="$t('Werte zurücksetzen')"
                                    @click="reset(newSchoolYear)"
                                />
                            </td>
                        </tr>
                        <tr
                            v-for="schoolYear in scope.data"
                            :class="{justSaved: isJustSaved(schoolYear)}"
                            class="kgr-table__row"
                        >
                            <td class="kgr-table__cell">
                                <template v-if="editing(schoolYear)">
                                    <input
                                        v-model="getEdit(schoolYear).name"
                                        type="text"
                                        class="kgr-input"
                                        value="'3'"
                                        axlength="100"
                                        :class="{ 'is-invalid': !isValidName(getEdit(schoolYear)) }"
                                        @blur="save(getEdit(schoolYear), scope.reload)"
                                    /></input>
                                    <div
                                        v-if="hasErrorAtField(schoolYear,'name')"
                                        class="errors kgr-color kgr-color--error"
                                    >
                                        {{ errorMessageForField(schoolYear,'name') }}
                                    </div>
                                </template>
                                <template
                                    v-else
                                    v-model="schoolYear.name"
                                >
                                    {{ schoolYear.name }}
                                </template>
                            </td>
                            <td class="kgr-table__cell">
                                <template v-if="editing(schoolYear)">
                                    <kgr-date-picker
                                        v-model="getEdit(schoolYear).start"
                                        :invalid="!isValidStart(getEdit(schoolYear))"
                                        @post-input="save(getEdit(schoolYear), scope.reload, 'start')"
                                    />
                                    <div
                                        v-if="hasErrorAtField(schoolYear,'start')"
                                        class="errors kgr-color kgr-color--error"
                                    >
                                        {{ errorMessageForField(schoolYear,'start') }}
                                    </div>
                                </template>
                                <template v-else>
                                    {{ moment(schoolYear.start).format('DD.MM.YYYY') }}
                                </template>
                            </td>
                            <td class="kgr-table__cell">
                                <template v-if="editing(schoolYear)">
                                    <kgr-date-picker
                                        v-model="getEdit(schoolYear).end"
                                        :invalid="!isValidEnd(getEdit(schoolYear))"
                                        @post-input="save(getEdit(schoolYear), scope.reload, 'end')"
                                    />
                                    <div
                                        v-if="hasErrorAtField(schoolYear,'end')"
                                        class="errors kgr-color kgr-color--error"
                                    >
                                        {{ errorMessageForField(schoolYear,'end') }}
                                    </div>
                                </template>
                                <template v-else>
                                    {{ moment(schoolYear.end).format('DD.MM.YYYY') }}
                                </template>
                            </td>
                            <td class="kgr-table__cell">
                                <template v-if="editing(schoolYear)">
                                    <kgr-date-picker
                                        v-model="getEdit(schoolYear).immutableDate"
                                        :invalid="!isValidImmutableDate(getEdit(schoolYear))"
                                        @post-input="save(getEdit(schoolYear), scope.reload)"
                                    />
                                    <div
                                        v-if="hasErrorAtField(schoolYear,'immutableDate')"
                                        class="errors kgr-color kgr-color--error"
                                    >
                                        {{ errorMessageForField(schoolYear,'immutableDate') }}
                                    </div>
                                </template>
                                <template v-else>
                                    {{ moment(schoolYear.immutableDate).format('DD.MM.YYYY') }}
                                </template>
                            </td>
                            <td class="kgr-table__cell kgr-table__cell--actions">
                                <kgr-icon-reset
                                    class="kgr-table__action"
                                    :disabled="!editing(schoolYear)"
                                    :title="editing(schoolYear) ? $t('Werte zurücksetzen') : '' "
                                    @click="editing(schoolYear) && reset(schoolYear)"
                                />
                                <kgr-icon-edit
                                    class="kgr-table__action"
                                    :disabled="!schoolYear.isEditable"
                                    :title=" schoolYear.isEditable ? $t('edit') : $t('SchoolYear.notEditable',{'name': schoolYear.name}) "
                                    @click="edit(schoolYear)"
                                />
                                <kgr-icon-delete
                                    class="kgr-table__action"
                                    :disabled="!schoolYear.isDeletable"
                                    :title=" schoolYear.isDeletable ? $t('delete') : $t('SchoolYear.notDeletable',{'name': schoolYear.name}) "
                                    @click="remove(schoolYear, scope.reload, scope.remove)"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </kgr-school-year-data-provider>
    </div>
</template>
<script>

import DatePicker from '../common/form/picker/DatePicker';
import IconDelete from '../common/icon/IconDelete';
import IconEdit from '../common/icon/IconEdit';
import IconReset from '../common/icon/IconReset';
import SchoolYear from '../../js/dto/SchoolYear';
import SchoolYearDataProvider from '../data-provider/SchoolYearDataProvider';
import SchoolYearRepository from '../../js/repository/SchoolYearRepository';

export default {
    components: {
        'kgr-icon-edit': IconEdit,
        'kgr-icon-reset': IconReset,
        'kgr-icon-delete': IconDelete,
        'kgr-date-picker': DatePicker,
        'kgr-school-year-data-provider': SchoolYearDataProvider,
    },
    props: {
        kindergartenId: {
            type: Number,
            required: true,
        },
        nameMaxLength: {
            type: Number,
            required: false,
            default: 100
        }
    },
    data() {
        return {
            errors: {},
            justSaved: {},
            newSchoolYear: new SchoolYear(this.kindergartenId),
            editSchoolYears: [],
        }
    },
    methods: {
        editing(schoolYear) {
            return this.getEditIndex(schoolYear) !== -1;
        },
        getEdit(schoolYear) {
            return this.editSchoolYears[this.getEditIndex(schoolYear)];
        },
        getEditIndex(schoolYear) {
            return this.editSchoolYears.map(editSchoolYear => editSchoolYear.id).indexOf(schoolYear.id);
        },
        isValidName(schoolYear) {
            return schoolYear.name.length > 0 && schoolYear.name.length <= this.nameMaxLength && !this.hasErrorAtField(schoolYear, 'name');
        },
        isValidStart(schoolYear) {
            return schoolYear.start && this.isValidDateRange(schoolYear) && !this.hasErrorAtField(schoolYear,'start') && this.isValidDateString(schoolYear.start);
        },
        isValidEnd(schoolYear) {
            return schoolYear.end && this.isValidDateRange(schoolYear) && !this.hasErrorAtField(schoolYear,'end') && this.isValidDateString(schoolYear.end);
        },
        isValidImmutableDate(schoolYear) {
            return schoolYear.immutableDate && this.isInRuntime(schoolYear) && !this.hasErrorAtField(schoolYear,'immutableDate') && this.isValidDateString(schoolYear.immutableDate);
        },
        isValidDateString(date)
        {
            let regexp = new RegExp('[0-9]{2}\\.[0-9]{2}.[0-9]{4}');
            return regexp.test(date);
        },
        isValidDateRange(schoolYear) {
            if (!schoolYear.end || !schoolYear.start) {
                return false;
            }

            return this.moment(schoolYear.end, 'DD.MM.YYYY') >= this.moment(schoolYear.start, 'DD.MM.YYYY');
        },
        isValid(schoolYear)
        {
            return this.isValidName(schoolYear) && this.isValidStart(schoolYear) && this.isValidEnd(schoolYear) && this.isValidImmutableDate(schoolYear);
        },
        isInRuntime(schoolYear) {
            if (!this.isValidDateRange(schoolYear)) {
                return false;
            }
            return this.moment(schoolYear.immutableDate, 'DD.MM.YYYY') >= this.moment(schoolYear.start, 'DD.MM.YYYY') &&
                    this.moment(schoolYear.immutableDate, 'DD.MM.YYYY') <= this.moment(schoolYear.end, 'DD.MM.YYYY');
        },
        edit(schoolYear) {
            if (this.editing(schoolYear)) {
                return;
            }

            this.editSchoolYears.push(schoolYear.toData());
        },
        remove(schoolYear, reload, remove) {
            showConfirm(this.$t('confirm'), this.$t('schoolYear.confirm.delete', {'name': schoolYear.name}), () => {
                SchoolYearRepository
                    .delete(schoolYear.id)
                    .then(() => {
                        this.editSchoolYears = this.editSchoolYears.filter(s => s.id !== schoolYear.id);
                        remove(schoolYear);
                        this.$notify.success('schoolYear.delete.success', {'name': schoolYear.name});
                        reload();
                    })
                    .catch(error => {
                        if (error.status === 409) {
                            this.$notify.error('schoolYear.delete.conflict', {'name': schoolYear.name});
                        } else {
                            this.$notify.error('saveChanges.error')
                        }
                    });
            }, 'Ok');
        },
        create(schoolYear, reload) {
            SchoolYearRepository
                .create(schoolYear.name, schoolYear.start, schoolYear.end, schoolYear.immutableDate, schoolYear.kindergartenId)
                .then(() => {
                    this.newSchoolYear = new SchoolYear(this.kindergartenId);
                    this.$notify.success('saveChanges.success');
                    reload();
                })
                .catch(error => {this.handleError(schoolYear, error); });
        },
        update(schoolYear, reload) {
            SchoolYearRepository
                .update(schoolYear)
                .then(() => {
                    this.editSchoolYears = [];
                    this.addJustSaved(schoolYear);
                    reload();
                })
                .catch(error => {this.handleError(schoolYear, error); });
        },
        reset(schoolYear) {
            this.removeError(schoolYear);
            if(schoolYear.id)
            {
                this.editSchoolYears = this.editSchoolYears.filter(s => s.id !== schoolYear.id);
            }
            else
            {
                // this.$set(this.errors, '0', new Error());
                this.newSchoolYear = new SchoolYear(this.kindergartenId);
            }
        },
        handleError(schoolYear, error) {
            let id = schoolYear.id || 0;
            this.$set(this.errors, id, error)
            this.$notify.error('saveChanges.error');
        },
        hasErrorAtField(schoolYear, field) {
            let id = schoolYear.id || 0;
            if(this.errors.hasOwnProperty(id))
            {
                return this.errors[id].forField(field);
            }

            return false;
        },
        errorMessageForField(schoolYear, field) {
            let id = schoolYear.id || 0;
            return this.hasErrorAtField(schoolYear, field) ? this.errors[id].messageForField(field) : false;
        },
        removeError(schoolYear) {
            let id = schoolYear.id || 0;
            if(this.errors.hasOwnProperty(id))
            {
                delete this.errors[id];
            }
        },
        save(schoolYear, reload, field = '') {
            if((this.hasErrorAtField(schoolYear, 'start') || this.hasErrorAtField(schoolYear, 'end')) && ('start' == field || 'end' == field)) {
                this.removeError(schoolYear);
            }

            if(this.isValid(schoolYear)) {
                schoolYear.id ? this.update(schoolYear, reload) : this.create(schoolYear, reload);
            }
        },
        addJustSaved(schoolYear) {
            let id = schoolYear.id || 0;
            this.justSaved[id] = true;
            let func = this.removeJustSaved;
            this.requestAnimation()
            setTimeout(function() {
                func(schoolYear)
            }, 2000);
        },
        removeJustSaved(schoolYear){
            let id = schoolYear.id || 0;
            if(this.justSaved.hasOwnProperty(id))
            {
                this.justSaved[id] = false;
            }
        },
        isJustSaved(schoolYear)
        {
            let id = schoolYear.id || 0;
            if(this.justSaved.hasOwnProperty(id))
            {
                return this.justSaved[id];
            }
            return false;
        },
        requestAnimation(  ){
            let elements = $('tr.justSaved td');
            elements.each(function() {this.style.animation = 'none';})
            window.requestAnimationFrame(function(){
                elements.each(function() {this.style.animation = 'justSaved normal 1s 0s ease-in-out';})
            });
        }
    },
}

</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .button_save {
        display: block;
        margin-left: auto;
    }
    .invalid {
        border-color: #F44336;
    }

    tr.justSaved td {
        transition:all 0.5s ease-in-out;
        animation:justSaved normal 1s 0s ease-in-out;
    }
    @keyframes justSaved {
        0% {background-color: rgba(255,255,0,0)}
        50% {background-color: rgba(255,255,0,1)}
        100% {background-color: rgba(255,255,0,0)}
    }
</style>
